import { render, staticRenderFns } from "./IcoClassProgramContent.vue?vue&type=template&id=62979827"
import script from "./IcoClassProgramContent.vue?vue&type=script&lang=js"
export * from "./IcoClassProgramContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports